import React, { createContext, useState, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Load saved language preference on initial render
    const savedLanguage = localStorage.getItem('preferredLanguage');
    return (savedLanguage && ['russian', 'tajik'].includes(savedLanguage)) ? savedLanguage : 'tajik';
  });

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('preferredLanguage', lang);
  };

  const getText = (russianText, tajikText) => {
    return language === 'russian' ? russianText : tajikText;
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, getText }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
